import { DeleteIcon, EditIcon, LabeledIcon } from 'components/Icon';
import React from 'react';
import { useHistory } from 'react-router';

import * as paths from 'app-router/paths';
import { useStore } from 'stores';
import { Feature } from 'stores/FeatureStore';
import { DefaultCopyToClipboard } from 'components/CopyToClipboard';
import { SimpleInlineHelp } from 'components/InlineHelp';

interface Props
{
  feature: Feature,
}

export const ViewForm: React.FC<Props> = ({feature}: Props) =>
{
  const history = useHistory();
  const { uiStore, featureStore } = useStore();

  const locationState = history.location.state as { isCancelRequired: boolean };

  const editFeatureHandler = () => history.push(paths.buildFeatureEditPath(feature.token || ''));
  const createFeatureHandler = () => history.push(paths.buildFeatureCreatePath());
  const toListHandler = () => history.push(paths.buildFeatureListPath());
  const cancelHandler = () =>
  {
    featureStore.clearError();
    history.goBack();
  }
  const deleteFeatureHandler = async () =>
  {
    if (window.confirm(uiStore.labels.pages.features.deleteFeatureConfirmation.apply({featureName: feature.name})))
    {
      await featureStore.deleteAsync(feature.token || '');
      if (!featureStore.isError)
      {
        history.push(paths.buildFeatureListPath());
      }
    }
  }
  return (
    <>
      <div className="fields">
        <label>
          {uiStore.labels.common.forms.feature.token.label}:<SimpleInlineHelp>{uiStore.labels.help.features.token.about}</SimpleInlineHelp>
          <DefaultCopyToClipboard text={feature.token} />
          <input type="text" value={feature.token} readOnly={true} />
        </label>
        <label>
          {uiStore.labels.common.forms.feature.name.label}:
          <input type="text" value={feature.name} readOnly={true} />
        </label>
        <label>
          {uiStore.labels.common.forms.feature.description.label}:
          <input type="text" value={feature.description} readOnly={true} />
        </label>

        <div className="info">
          <p>{uiStore.labels.common.forms.feature.createdBy.apply({by: feature.created_by, at: new Date(Date.parse(feature.created_at || '')).toLocaleString(),})}</p>
          <p>{uiStore.labels.common.forms.feature.updatedBy.apply({by: feature.updated_by, at: new Date(Date.parse(feature.updated_at || '')).toLocaleString(),})}</p>
        </div>
      </div>

      <div className="actions">
        <button onClick={editFeatureHandler}><LabeledIcon label={uiStore.labels.common.forms.edit}><EditIcon /></LabeledIcon></button>
        <button onClick={deleteFeatureHandler}><LabeledIcon label={uiStore.labels.common.forms.delete}><DeleteIcon/></LabeledIcon></button>
        <button onClick={createFeatureHandler}>{uiStore.labels.common.forms.createAnother}</button>
        {
          locationState?.isCancelRequired
          ? <button onClick={cancelHandler}>{uiStore.labels.common.forms.cancel}</button>
          : <button onClick={toListHandler}>{uiStore.labels.common.forms.toList}</button>
        }
      </div>
    </>
  );
};